import { useLayoutEffect, useState } from 'react';

import { LayoutProvider } from './provider';

import BottomAdContext from '@/context/BottomAdContext';
import BaseFooter from '@/layouts/baseFooter';
import BaseHeader from '@/layouts/baseHeader';
import IndexDialogManage from '@/layouts/baseHeader/components/AdDialogManage';
import BottomFloatAd from '@/layouts/baseHeader/components/BottomFloatAd';
import useUserStore from '@/store/user';

export default function BaseLayout(props) {
  const {
    children,
    resourceData,
    websiteSectionList,
    catalogList,
    isMro,
    indexPage,
    headerAd,
    hideHeader = false,
    isLgScreen,
    logined,
    notIndexHeaderAdapter,
    onlySScreen,
    pageAutoRefreshLoginInfo = null, // pageAutoRefreshLoginInfo ： 页面自定义的登录后回调
    isNeedTopAd,
    indexAd,
    isShowBottomAd,
    isShowAdDialog,
    globalSearchKeyword,
    showMemberWebsite,
    showFriendWebsite = true,
  } = props;
  const [newResourceData] = useState(resourceData);
  const [newWebsiteSectionList] = useState(websiteSectionList);
  const [animateShow, setAnimateShow] = useState(false); //动效的显示状态
  const { updateProjectConfigVO, updateCommonConfigVO } = useUserStore();

  useLayoutEffect(() => {
    updateProjectConfigVO(resourceData?.projectConfigVO);
    updateCommonConfigVO(resourceData?.commonConfigVO);
  }, []);

  return (
    <BottomAdContext.Provider value={{ animateShow, setAnimateShow }}>
      <LayoutProvider
        resourceData={newResourceData}
        websiteSectionList={newWebsiteSectionList}
        catalogList={catalogList}
        isMro={isMro}
        indexPage={indexPage}
        onlySScreen={onlySScreen}
        globalSearchKeyword={globalSearchKeyword}
        showMemberWebsite={showMemberWebsite}
        showFriendWebsite={showFriendWebsite}
      >
        {!indexPage && !hideHeader && (
          <BaseHeader
            headerAd={headerAd}
            logined={logined}
            isLgScreen={isLgScreen}
            notIndexHeaderAdapter={notIndexHeaderAdapter}
            isNeedTopAd={isNeedTopAd}
            pageAutoRefreshLoginInfo={pageAutoRefreshLoginInfo}
          />
        )}
        <main>{children}</main>
        <BaseFooter></BaseFooter>
        {isShowBottomAd && <BottomFloatAd headerAd={headerAd} />}
        {isShowAdDialog && indexAd && <IndexDialogManage grey={indexAd?.skinColour} />}
      </LayoutProvider>
    </BottomAdContext.Provider>
  );
}
